const cards = [
    {
        "color": "blue",
        "shape": "bird",
        "number": "01",
        "shading": "empty",
        "source": require("../assets/images/BLUE/B_E01.png"),
        "id": "B_E01.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "bird",
        "number": "02",
        "shading": "empty",
        "source": require("../assets/images/BLUE/B_E02.png"),
        "id": "B_E02.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "bird",
        "number": "03",
        "shading": "empty",
        "source": require("../assets/images/BLUE/B_E03.png"),
        "id": "B_E03.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "bird",
        "number": "01",
        "shading": "full",
        "source": require("../assets/images/BLUE/B_F01.png"),
        "id": "B_F01.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "bird",
        "number": "02",
        "shading": "full",
        "source": require("../assets/images/BLUE/B_F02.png"),
        "id": "B_F02.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "bird",
        "number": "03",
        "shading": "full",
        "source": require("../assets/images/BLUE/B_F03.png"),
        "id": "B_F03.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "bird",
        "number": "01",
        "shading": "striped",
        "source": require("../assets/images/BLUE/B_S01.png"),
        "id": "B_S01.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "bird",
        "number": "02",
        "shading": "striped",
        "source": require("../assets/images/BLUE/B_S02.png"),
        "id": "B_S02.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "bird",
        "number": "03",
        "shading": "striped",
        "source": require("../assets/images/BLUE/B_S03.png"),
        "id": "B_S03.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "crane",
        "number": "01",
        "shading": "empty",
        "source": require("../assets/images/BLUE/C_E01.png"),
        "id": "C_E01.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "crane",
        "number": "02",
        "shading": "empty",
        "source": require("../assets/images/BLUE/C_E02.png"),
        "id": "C_E02.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "crane",
        "number": "03",
        "shading": "empty",
        "source": require("../assets/images/BLUE/C_E03.png"),
        "id": "C_E03.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "crane",
        "number": "01",
        "shading": "full",
        "source": require("../assets/images/BLUE/C_F01.png"),
        "id": "C_F01.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "crane",
        "number": "02",
        "shading": "full",
        "source": require("../assets/images/BLUE/C_F02.png"),
        "id": "C_F02.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "crane",
        "number": "03",
        "shading": "full",
        "source": require("../assets/images/BLUE/C_F03.png"),
        "id": "C_F03.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "crane",
        "number": "01",
        "shading": "striped",
        "source": require("../assets/images/BLUE/C_S01.png"),
        "id": "C_S01.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "crane",
        "number": "02",
        "shading": "striped",
        "source": require("../assets/images/BLUE/C_S02.png"),
        "id": "C_S02.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "crane",
        "number": "03",
        "shading": "striped",
        "source": require("../assets/images/BLUE/C_S03.png"),
        "id": "C_S03.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "squirrel",
        "number": "01",
        "shading": "empty",
        "source": require("../assets/images/BLUE/S_E01.png"),
        "id": "S_E01.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "squirrel",
        "number": "02",
        "shading": "empty",
        "source": require("../assets/images/BLUE/S_E02.png"),
        "id": "S_E02.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "squirrel",
        "number": "03",
        "shading": "empty",
        "source": require("../assets/images/BLUE/S_E03.png"),
        "id": "S_E03.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "squirrel",
        "number": "01",
        "shading": "full",
        "source": require("../assets/images/BLUE/S_F01.png"),
        "id": "S_F01.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "squirrel",
        "number": "02",
        "shading": "full",
        "source": require("../assets/images/BLUE/S_F02.png"),
        "id": "S_F02.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "squirrel",
        "number": "03",
        "shading": "full",
        "source": require("../assets/images/BLUE/S_F03.png"),
        "id": "S_F03.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "squirrel",
        "number": "01",
        "shading": "striped",
        "source": require("../assets/images/BLUE/S_S01.png"),
        "id": "S_S01.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "squirrel",
        "number": "02",
        "shading": "striped",
        "source": require("../assets/images/BLUE/S_S02.png"),
        "id": "S_S02.png_BLUE"
    },
    {
        "color": "blue",
        "shape": "squirrel",
        "number": "03",
        "shading": "striped",
        "source": require("../assets/images/BLUE/S_S03.png"),
        "id": "S_S03.png_BLUE"
    },
    {
        "color": "green",
        "shape": "bird",
        "number": "01",
        "shading": "empty",
        "source": require("../assets/images/GREEN/B_E01.png"),
        "id": "B_E01.png_GREEN"
    },
    {
        "color": "green",
        "shape": "bird",
        "number": "02",
        "shading": "empty",
        "source": require("../assets/images/GREEN/B_E02.png"),
        "id": "B_E02.png_GREEN"
    },
    {
        "color": "green",
        "shape": "bird",
        "number": "03",
        "shading": "empty",
        "source": require("../assets/images/GREEN/B_E03.png"),
        "id": "B_E03.png_GREEN"
    },
    {
        "color": "green",
        "shape": "bird",
        "number": "01",
        "shading": "full",
        "source": require("../assets/images/GREEN/B_F01.png"),
        "id": "B_F01.png_GREEN"
    },
    {
        "color": "green",
        "shape": "bird",
        "number": "02",
        "shading": "full",
        "source": require("../assets/images/GREEN/B_F02.png"),
        "id": "B_F02.png_GREEN"
    },
    {
        "color": "green",
        "shape": "bird",
        "number": "03",
        "shading": "full",
        "source": require("../assets/images/GREEN/B_F03.png"),
        "id": "B_F03.png_GREEN"
    },
    {
        "color": "green",
        "shape": "bird",
        "number": "01",
        "shading": "striped",
        "source": require("../assets/images/GREEN/B_S01.png"),
        "id": "B_S01.png_GREEN"
    },
    {
        "color": "green",
        "shape": "bird",
        "number": "02",
        "shading": "striped",
        "source": require("../assets/images/GREEN/B_S02.png"),
        "id": "B_S02.png_GREEN"
    },
    {
        "color": "green",
        "shape": "bird",
        "number": "03",
        "shading": "striped",
        "source": require("../assets/images/GREEN/B_S03.png"),
        "id": "B_S03.png_GREEN"
    },
    {
        "color": "green",
        "shape": "crane",
        "number": "01",
        "shading": "empty",
        "source": require("../assets/images/GREEN/C_E01.png"),
        "id": "C_E01.png_GREEN"
    },
    {
        "color": "green",
        "shape": "crane",
        "number": "02",
        "shading": "empty",
        "source": require("../assets/images/GREEN/C_E02.png"),
        "id": "C_E02.png_GREEN"
    },
    {
        "color": "green",
        "shape": "crane",
        "number": "03",
        "shading": "empty",
        "source": require("../assets/images/GREEN/C_E03.png"),
        "id": "C_E03.png_GREEN"
    },
    {
        "color": "green",
        "shape": "crane",
        "number": "01",
        "shading": "full",
        "source": require("../assets/images/GREEN/C_F01.png"),
        "id": "C_F01.png_GREEN"
    },
    {
        "color": "green",
        "shape": "crane",
        "number": "02",
        "shading": "full",
        "source": require("../assets/images/GREEN/C_F02.png"),
        "id": "C_F02.png_GREEN"
    },
    {
        "color": "green",
        "shape": "crane",
        "number": "03",
        "shading": "full",
        "source": require("../assets/images/GREEN/C_F03.png"),
        "id": "C_F03.png_GREEN"
    },
    {
        "color": "green",
        "shape": "crane",
        "number": "01",
        "shading": "striped",
        "source": require("../assets/images/GREEN/C_S01.png"),
        "id": "C_S01.png_GREEN"
    },
    {
        "color": "green",
        "shape": "crane",
        "number": "02",
        "shading": "striped",
        "source": require("../assets/images/GREEN/C_S02.png"),
        "id": "C_S02.png_GREEN"
    },
    {
        "color": "green",
        "shape": "crane",
        "number": "03",
        "shading": "striped",
        "source": require("../assets/images/GREEN/C_S03.png"),
        "id": "C_S03.png_GREEN"
    },
    {
        "color": "green",
        "shape": "squirrel",
        "number": "01",
        "shading": "empty",
        "source": require("../assets/images/GREEN/S_E01.png"),
        "id": "S_E01.png_GREEN"
    },
    {
        "color": "green",
        "shape": "squirrel",
        "number": "02",
        "shading": "empty",
        "source": require("../assets/images/GREEN/S_E02.png"),
        "id": "S_E02.png_GREEN"
    },
    {
        "color": "green",
        "shape": "squirrel",
        "number": "03",
        "shading": "empty",
        "source": require("../assets/images/GREEN/S_E03.png"),
        "id": "S_E03.png_GREEN"
    },
    {
        "color": "green",
        "shape": "squirrel",
        "number": "01",
        "shading": "full",
        "source": require("../assets/images/GREEN/S_F01.png"),
        "id": "S_F01.png_GREEN"
    },
    {
        "color": "green",
        "shape": "squirrel",
        "number": "02",
        "shading": "full",
        "source": require("../assets/images/GREEN/S_F02.png"),
        "id": "S_F02.png_GREEN"
    },
    {
        "color": "green",
        "shape": "squirrel",
        "number": "03",
        "shading": "full",
        "source": require("../assets/images/GREEN/S_F03.png"),
        "id": "S_F03.png_GREEN"
    },
    {
        "color": "green",
        "shape": "squirrel",
        "number": "01",
        "shading": "striped",
        "source": require("../assets/images/GREEN/S_S01.png"),
        "id": "S_S01.png_GREEN"
    },
    {
        "color": "green",
        "shape": "squirrel",
        "number": "02",
        "shading": "striped",
        "source": require("../assets/images/GREEN/S_S02.png"),
        "id": "S_S02.png_GREEN"
    },
    {
        "color": "green",
        "shape": "squirrel",
        "number": "03",
        "shading": "striped",
        "source": require("../assets/images/GREEN/S_S03.png"),
        "id": "S_S03.png_GREEN"
    },
    {
        "color": "red",
        "shape": "bird",
        "number": "01",
        "shading": "empty",
        "source": require("../assets/images/RED/B_E01.png"),
        "id": "B_E01.png_RED"
    },
    {
        "color": "red",
        "shape": "bird",
        "number": "02",
        "shading": "empty",
        "source": require("../assets/images/RED/B_E02.png"),
        "id": "B_E02.png_RED"
    },
    {
        "color": "red",
        "shape": "bird",
        "number": "03",
        "shading": "empty",
        "source": require("../assets/images/RED/B_E03.png"),
        "id": "B_E03.png_RED"
    },
    {
        "color": "red",
        "shape": "bird",
        "number": "01",
        "shading": "full",
        "source": require("../assets/images/RED/B_F01.png"),
        "id": "B_F01.png_RED"
    },
    {
        "color": "red",
        "shape": "bird",
        "number": "02",
        "shading": "full",
        "source": require("../assets/images/RED/B_F02.png"),
        "id": "B_F02.png_RED"
    },
    {
        "color": "red",
        "shape": "bird",
        "number": "03",
        "shading": "full",
        "source": require("../assets/images/RED/B_F03.png"),
        "id": "B_F03.png_RED"
    },
    {
        "color": "red",
        "shape": "bird",
        "number": "01",
        "shading": "striped",
        "source": require("../assets/images/RED/B_S01.png"),
        "id": "B_S01.png_RED"
    },
    {
        "color": "red",
        "shape": "bird",
        "number": "02",
        "shading": "striped",
        "source": require("../assets/images/RED/B_S02.png"),
        "id": "B_S02.png_RED"
    },
    {
        "color": "red",
        "shape": "bird",
        "number": "03",
        "shading": "striped",
        "source": require("../assets/images/RED/B_S03.png"),
        "id": "B_S03.png_RED"
    },
    {
        "color": "red",
        "shape": "crane",
        "number": "01",
        "shading": "empty",
        "source": require("../assets/images/RED/C_E01.png"),
        "id": "C_E01.png_RED"
    },
    {
        "color": "red",
        "shape": "crane",
        "number": "02",
        "shading": "empty",
        "source": require("../assets/images/RED/C_E02.png"),
        "id": "C_E02.png_RED"
    },
    {
        "color": "red",
        "shape": "crane",
        "number": "03",
        "shading": "empty",
        "source": require("../assets/images/RED/C_E03.png"),
        "id": "C_E03.png_RED"
    },
    {
        "color": "red",
        "shape": "crane",
        "number": "01",
        "shading": "full",
        "source": require("../assets/images/RED/C_F01.png"),
        "id": "C_F01.png_RED"
    },
    {
        "color": "red",
        "shape": "crane",
        "number": "02",
        "shading": "full",
        "source": require("../assets/images/RED/C_F02.png"),
        "id": "C_F02.png_RED"
    },
    {
        "color": "red",
        "shape": "crane",
        "number": "03",
        "shading": "full",
        "source": require("../assets/images/RED/C_F03.png"),
        "id": "C_F03.png_RED"
    },
    {
        "color": "red",
        "shape": "crane",
        "number": "01",
        "shading": "striped",
        "source": require("../assets/images/RED/C_S01.png"),
        "id": "C_S01.png_RED"
    },
    {
        "color": "red",
        "shape": "crane",
        "number": "02",
        "shading": "striped",
        "source": require("../assets/images/RED/C_S02.png"),
        "id": "C_S02.png_RED"
    },
    {
        "color": "red",
        "shape": "crane",
        "number": "03",
        "shading": "striped",
        "source": require("../assets/images/RED/C_S03.png"),
        "id": "C_S03.png_RED"
    },
    {
        "color": "red",
        "shape": "squirrel",
        "number": "01",
        "shading": "empty",
        "source": require("../assets/images/RED/S_E01.png"),
        "id": "S_E01.png_RED"
    },
    {
        "color": "red",
        "shape": "squirrel",
        "number": "02",
        "shading": "empty",
        "source": require("../assets/images/RED/S_E02.png"),
        "id": "S_E02.png_RED"
    },
    {
        "color": "red",
        "shape": "squirrel",
        "number": "03",
        "shading": "empty",
        "source": require("../assets/images/RED/S_E03.png"),
        "id": "S_E03.png_RED"
    },
    {
        "color": "red",
        "shape": "squirrel",
        "number": "01",
        "shading": "full",
        "source": require("../assets/images/RED/S_F01.png"),
        "id": "S_F01.png_RED"
    },
    {
        "color": "red",
        "shape": "squirrel",
        "number": "02",
        "shading": "full",
        "source": require("../assets/images/RED/S_F02.png"),
        "id": "S_F02.png_RED"
    },
    {
        "color": "red",
        "shape": "squirrel",
        "number": "03",
        "shading": "full",
        "source": require("../assets/images/RED/S_F03.png"),
        "id": "S_F03.png_RED"
    },
    {
        "color": "red",
        "shape": "squirrel",
        "number": "01",
        "shading": "striped",
        "source": require("../assets/images/RED/S_S01.png"),
        "id": "S_S01.png_RED"
    },
    {
        "color": "red",
        "shape": "squirrel",
        "number": "02",
        "shading": "striped",
        "source": require("../assets/images/RED/S_S02.png"),
        "id": "S_S02.png_RED"
    },
    {
        "color": "red",
        "shape": "squirrel",
        "number": "03",
        "shading": "striped",
        "source": require("../assets/images/RED/S_S03.png"),
        "id": "S_S03.png_RED"
    }
];

export default cards



// WEBPACK FOOTER //
// ./src/data/cards.js